export default __webpack_public_path__ + "src/shared/svg/providers/6605575c7eecd3b8d034bb85c74126bd.png";